












































































import Vue from "vue";
import { OrgAccess } from "@/types/REST-API-DOMAIN/OrgAccess";
import { mapGetters } from "vuex";
import { ROLES } from "@/enums";
import { getModule } from "vuex-module-decorators";
import SubscriptionSignup from "@/store/modules/SubscriptionSignup";
import GetterTypes from "@/store/GetterTypes";
import Sidebar from "@/views/academy/common/Sidebar.vue";
import SubscriptionManageTeams from "@/components/Subscriptions/SubscriptionManageTeams.vue";
import { Routes } from "@/router/Routes";

interface State {
  store: SubscriptionSignup;
  org: OrgAccess | null;
  ROLES: typeof ROLES;
  rules: any;
  activeTeamCount: number;
  manageTeams: boolean;
  activeTeams: any[];
  archivedTeams: any[];
}

export default Vue.extend({
  name: "SubscriptionLicenses",
  components: { Sidebar, SubscriptionManageTeams },
  data(): State {
    return {
      store: getModule(SubscriptionSignup, this.$store),
      org: null,
      ROLES: ROLES,
      rules: {
        required: (value: any) => !!value || "Required."
      },
      activeTeamCount: 0,
      manageTeams: false,
      activeTeams: [],
      archivedTeams: []
    };
  },
  async mounted() {
    if (!this.store.subscriptionVO.orgName && !this.$route.params.orgId) {
      this.$router.push(Routes.SUBSCRIPTIONS_SIGNUP);
    }
    if (this.$route.params.orgId) {
      const orgAccess = {
        orgName: this.organization.name,
        orgId: this.organization.id,
        canEditBillingInfo: this.organization.canEditBilling,
        canViewOrderHistory: this.organization.canEditBillingInfo
      } as OrgAccess;
      this.activeTeamCount = this.organization.activeTeamCount;
      await this.store.setExistingOrg(orgAccess);
    }
    await this.store.getProductsAndPrices();
  },
  methods: {
    toggleManageTeams() {
      this.manageTeams = !this.manageTeams;
    },
    updateTeams(activeTeamCount: number) {
      this.activeTeamCount = activeTeamCount;
    },
    nextPage() {
      this.$route.params.orgId
        ? this.$router.push(`/${this.$route.params.orgId}/subscriptions/select`)
        : this.$router.push("/subscriptions/select");
    },
    previousPage() {
      this.$router.push("/subscriptions/signup");
    }
  },
  computed: {
    ...mapGetters({
      user: GetterTypes.GET_USER,
      organization: GetterTypes.GET_ORGANIZATION
    }),
    insufficientLicenses(): boolean {
      return (
        this.organization &&
        this.activeTeamCount > this.store.subscriptionVO.teams
      );
    },
    continueBtnDisabled(): boolean {
      return (
        !(this.store.subscriptionVO.teams > 0) || this.insufficientLicenses
      );
    }
  }
});
